(() => {
	function linkTip() {
		return {
			restrict: 'E',
			replace: true,
			transclude: true,
			scope: {},
			template: '<i class="fi fi-edit"></i>'
		};
	}

	angular.module('main').directive('linkTip', linkTip);
})();

(() => {
	function modalLinkEditor(messageService) {
		return {
			restrict: 'AE',
			replace: true,
			transclude: true,
			scope: {
				linkData: '=snLinkData',
				snModal: '='
			},
			template: `
                    <div>
                        <div id=\"\" class=\"modal modal-link-editor modal-center fade\" data-backdrop=\"false\" data-keyboard=\"false\">
                          <div class=\"modal-dialog\">
                            <form class=\"modal-content\" ng-submit="saveLink()">

                              <div class=\"modal-header\">
                                <button type=\"button\" class='close' ng-click='closeModal()'>&times;</button>
                                <h3 class=\"modal-title\">Insert or edit link<\/h3>
                              <\/div>

                              <div class=\"modal-body\">
                                <div class="field-info">
                                  <h4>Link text</h4>
                                  <textarea class="form-control" type="text" placeholder="Text to display"
                                  ng-model="linkData.linkTo" required maxlength="255" style="height: 33px; padding-top: 6px !important"></textarea>
                                </div>

                                <div class="field-info">
                                  <h4>Link to website or email address</h4>
                                  <textarea class="form-control transition-0" type="text" placeholder="Type the website url including http:// or email address here"
                                  ng-model="linkData.url" required maxlength="255" ng-disabled=\"urlLooked\" style="height: 33px; padding-top: 6px !important"></textarea>
                                </div>

                              <\/div>

                              <div class=\"modal-footer modal-foot\">
                                <button type='submit' class=\"btn btn-success btn-lg\">Insert link<\/button>
                                <button type='button' class=\"btn btn-default btn-lg\" ng-click=\"removeLink()\">Remove link<\/button>
                              <\/div>

                            <\/form>
                          <\/div>
                        <\/div>
                        <div class='modal-link-editor__background'><\/div>
                    <\/div>
            `,
			link(scope) {
				let editEl;
				const lookedLinks = [
					'%contract_link%',
					'%invoice_link%',
					'%quote_link%',
					'%questionnaire_link%',
					'%galleries_link%'
				];

				scope.urlLooked = false;

				scope.saveLink = function() {
					let isEmail;
					if (isIncorrectUrl(scope.linkData.url)) {
						isEmail = isMail(scope.linkData.url);

						if ((isEmail && isIncorrectMail(scope.linkData.url)) || !isEmail) {
							messageService.showToaster('e_0', 'generalValidation');
							return false;
						}
					}

					if (isEmail !== undefined) {
						scope.linkData.url = `mailto:${scope.linkData.url}`;
					}
					// fix this code by rules EsLint block-scoped-var
					editEl[0].href = scope.linkData.url;
					editEl.text(scope.linkData.linkTo);
					editEl.removeClass(scope.linkData.select.slice(1));

					updateEditorData();
					clearData();
					switchModal();
				};

				scope.removeLink = function() {
					const boxEditor = editEl.parents('.sn-ta-editor');
					editEl.after(
						`<span> </span><span>${editEl.text()} </span><span> </span>`
					);
					editEl.remove();

					updateEditorData(boxEditor);
					clearData();
					switchModal();
				};

				scope.closeModal = function() {
					if (
						(scope.linkData.url &&
							(!isMail(scope.linkData.url) &&
								isIncorrectUrl(scope.linkData.url))) ||
						(isMail(scope.linkData.url) && isIncorrectMail(scope.linkData.url))
					) {
						const boxEditor = editEl.parents('.sn-ta-editor');
						editEl.after(`<span>${editEl.text()}</span>`);
						editEl.remove();

						updateEditorData(boxEditor);
					} else {
						editEl.removeClass(scope.linkData.select.slice(1));
						updateEditorData();
					}

					clearData();
					switchModal();
				};

				scope.$watch('linkData.openEditModal', (newValue, oldValue) => {
					if (newValue != oldValue) {
						console.log('newValue', newValue);
					}
				});

				scope.$watchCollection(
					'linkData.select',
					newValue => {
						if (newValue) {
							scope.linkData.url = '';
							scope.linkData.linkTo = '';

							editEl = $(scope.linkData.select);
							const editModal = editEl
								.parents('.sn-ta-editor')
								.find('.modal-link-editor');

							console.log('>>>>>');
							console.dir(editEl);
							if (editEl[0]) {
								scope.linkData.url = checkLookedLink(editEl[0].href);
								scope.linkData.linkTo = $(editEl[0]).text() || '';
							}

							$('.modal.in:not(.modal-link-editor)')
								.children('.modal-dialog')
								.css({ overflow: 'hidden' });

							editModal.modal('show');
							editModal
								.find('input')
								.first()
								.focus();
						} else {
							scope.linkData.url = '';
							scope.linkData.linkTo = '';
						}
					},
					true
				);

				function clearData() {
					scope.linkData.select = '';
					scope.linkData.url = '';
					scope.linkData.linkTo = '';
					const linkEditedContainer = $('.linkEdited').parents('.sn-ta-editor');

					linkEditedContainer.removeClass((index, css) =>
						(css.match(/(^|\s)link-edited-id-\S+/g) || []).join(' ')
					);

					$('.linkEdited').removeClass('linkEdited');
					$('.editLinkTips').hide();
					scope.urlLooked = false;
					$('.btn-link-edit').prop('disabled', true);
				}

				function switchModal() {
					$('.in.modal-link-editor')
						.modal('hide')
						.on('hidden.bs.modal', function(e) {
							if ($('.in.modal').length > 0) {
								document.body.classList.add('modal-open');
								$('.modal.in:not(.modal-link-editor)')
									.children('.modal-dialog')
									.css({ overflow: '' });
							}

							$('.linkEdited').removeClass('linkEdited');
							$(this).off('hidden.bs.modal');
							$('.modal.in:not(.modal-link-editor)')
								.children('.modal-dialog')
								.css({ overflow: '' });
						});
				}

				function checkLookedLink(tmpUrl) {
					if (!tmpUrl) {
						return '';
					}

					if (tmpUrl.indexOf('mailto:') === 0) {
						return (tmpUrl = tmpUrl.replace('mailto:', ''));
					}

					for (let i = 0, max = lookedLinks.length; i < max; i++) {
						if (tmpUrl.indexOf(lookedLinks[i]) > -1) {
							tmpUrl = lookedLinks[i];
							scope.urlLooked = true;
							break;
						}
					}

					return tmpUrl;
				}

				function updateEditorData(parent) {
					if (!parent) {
						parent = editEl.parents('.sn-ta-editor');
					}

					const element = angular.element(parent).find('*[id*=taText]');

					element.focus();
					element.blur();

					const input = $('.modal-link-editor')
						.find('input')
						.first();

					input.focus();
					input.blur();
				}

				function isIncorrectUrl(url) {
					if (url.indexOf('http://') === 0 && url.length > 7) {
						return false;
					}

					if (url.indexOf('https://') === 0 && url.length > 8) {
						return false;
					}

					for (let i = 0, max = lookedLinks.length; i < max; i++) {
						if (url.indexOf(lookedLinks[i]) > -1) {
							return false;
						}
					}

					return true;
				}

				function isMail(email) {
					return email.indexOf('@') > -1;
				}

				function isIncorrectMail(email) {
					const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
					return !re.test(email);
				}
			}
		};
	}

	modalLinkEditor.$inject = ['messageService'];

	angular.module('main').directive('modalLinkEditor', modalLinkEditor);
})();



// WEBPACK FOOTER //
// ./web/js/components/Modals/private/modalLinkEditor.js